export default __webpack_public_path__ + "static/media/SWT1180.34I-32303_-25821_0.6c40e766.jpg";